import {
    SET_SETTINGS,
    SET_DOWNLOAD_EVERYTHING,
    SET_RUN_CLIENTS_WITH_LOGGING,
    SET_RUN_CLIENTS_WITH_DX9,
    SET_SHOULD_MINIMIZE_TO_TRAY,
    SET_LOCALE,
    SET_TEST_SERVERS,
} from './constants'

// Initial state of the store
// The names and casing of the naming here is so that it matches
// what the backend expects
const initialState = {
    // LauncherEnableHardwareRendering: false,
    // LauncherEnableHighDpiScaling: false,
    // LauncherIgnoreCertErrors: false,
    LauncherLanguage: 'en',
    LauncherRunClientsWithDx9: false,
    LauncherRunClientsWithLogging: false,
    LauncherShouldDownloadEverything: false,
    LauncherShouldMinimizeToTray: false,
    LauncherTestServers: ['sisi', 'duality'],
    LauncherType: 0,
    // LauncherUseProxy: true,
    // ResManThreadCount: 0,
}

// Check whether default locale is 'zh' or 'en'
// TODO: Backend should not send empty for chinese, but rather 'zh'!
const defaultLocale = window.location.pathname.match(/\/zh\//i) ? 'zh' : 'en'

export default function settings(state = initialState, action) {
    const { type, payload } = action
    switch (type) {
        // Replace the backend settings
        case SET_SETTINGS: {
            return {
                ...payload,
                // The backend uses '' for english, while we prefer to use the string 'en'
                LauncherLanguage:
                    payload.LauncherLanguage === '' ? defaultLocale : payload.LauncherLanguage,
                // Default to 'Duallity'
                LauncherTestServers: [...(payload.LauncherTestServers || ['Duality'])],
            }
        }

        case SET_DOWNLOAD_EVERYTHING: {
            return {
                ...state,
                LauncherTestServers: [...state.LauncherTestServers],
                LauncherShouldDownloadEverything: payload,
            }
        }

        case SET_RUN_CLIENTS_WITH_LOGGING: {
            return {
                ...state,
                LauncherTestServers: [...state.LauncherTestServers],
                LauncherRunClientsWithLogging: payload,
            }
        }

        case SET_RUN_CLIENTS_WITH_DX9: {
            return {
                ...state,
                LauncherTestServers: [...state.LauncherTestServers],
                LauncherRunClientsWithDx9: payload,
            }
        }

        case SET_SHOULD_MINIMIZE_TO_TRAY: {
            return {
                ...state,
                LauncherTestServers: [...state.LauncherTestServers],
                LauncherShouldMinimizeToTray: payload,
            }
        }

        case SET_LOCALE: {
            return {
                ...state,
                LauncherTestServers: [...state.LauncherTestServers],
                LauncherLanguage: payload === '' ? defaultLocale : payload,
            }
        }

        case SET_TEST_SERVERS: {
            return {
                ...state,
                LauncherTestServers: [...payload],
            }
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/settings/reducer.js